export default class HandledError extends Error {
  constructor (err) {
    super('handled') // message
    this.error = err
  }
}
